import { render, staticRenderFns } from "./SmtpForm.vue?vue&type=template&id=422dcc12&"
import script from "./SmtpForm.vue?vue&type=script&lang=js&"
export * from "./SmtpForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports